import isEmpty from 'lodash/isEmpty';
import { listWM } from 'utils/Api';

import * as types from 'constants/ActionTypes';

function requestQualification() {
  return {
    type: types.REQUEST_QUALIFICATION,
  };
}

function requestQualificationSuccess(qualificationData) {
  return {
    type: types.REQUEST_QUALIFICATION_SUCCESS,
    qualificationData,
    receivedAt: Date.now(),
  };
}

function requestQualificationFailure(error) {
  return {
    type: types.REQUEST_QUALIFICATION_FAILURE,
    error,
  };
}

export function fetchQualification() {
  return (dispatch, getState) => {
    dispatch(requestQualification());

    const { loginReducer: { user: { EmployeeMasterID, token } } } = getState();

    const fetchConfig = {
      entity: 'EmployeeMasterQualification',
      headers: { Authorization: `Bearer ${token}` },
      params: {
        $filter: `Entity/EmployeeMasterID eq ${EmployeeMasterID}`,
      },
    };

    listWM(fetchConfig)
      .then(({ data }) => dispatch(requestQualificationSuccess(data)))
      .catch(error => dispatch(requestQualificationFailure(error)));
  };
}

export function fetchQualificationIfNeeded() {
  return (dispatch, getState) => {
    isEmpty(getState().qualificationReducer.qualificationData) &&
    dispatch(fetchQualification());
  };
}



// WEBPACK FOOTER //
// ./src/actions/qualification.js